import React from "react";

const App = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 px-6 py-12 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Marine Tax Advisors</h1>
      <p className="mb-4">Helping boat owners make smarter financial decisions.</p>

      <h2 className="text-xl font-semibold mt-8 mb-2">Decisions You’ll Need to Make</h2>
      <ul className="list-disc pl-5 mb-8">
        <li>Can I deduct my boat?</li>
        <li>Should I charter it?</li>
        <li>Do I need an LLC?</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">Resources</h2>
      <ul className="list-disc pl-5 mb-8">
        <li>Logbook & expense tracking tools</li>
        <li>Marine CPAs</li>
        <li>Surveyors & insurance</li>
        <li>Charter management platforms</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">Download</h2>
      <a
        href="https://example.com/logbook.pdf"
        className="text-blue-600 underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        IRS-Style Logbook PDF
      </a>

      <p className="text-xs text-gray-500 mt-10">
        This site is for informational purposes only and does not constitute tax or legal advice. Please consult a licensed professional.
      </p>
    </div>
  );
};

export default App;